import React, { useEffect, useState } from "react";
import { Container, Row } from "react-bootstrap";
import "./../../help/components/HelpPage.css";
import StoreImages from "./../../../assets/storelistback.png";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { getRequestcall } from "../../comman/util/getRequest";
import { GET_FAQ } from "../../constants/apiurl";
import { fetchHeaderContent } from "../../seoroute/redux/actions";
import i18next from "i18next";
import { fetchChangeLanguage } from "../../header/redux/actions";
import { LazyLoadImage } from "react-lazy-load-image-component";
import chevron_down from "../../../assets/chevron_down.svg";

function FaqsPage(props) {
  const { t } = useTranslation();
  const [selectQuetion, setSelectQuetion] = useState(0);
  const [faqList, setFaqList] = useState([]);
  let url = window.location.pathname.split("/");

  useEffect(() => {
    callGetFaqList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    props?.fetchHeaderContent(t("pages.meta.faq.title"), t("pages.meta.faq.description"), "");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props?.language]);

  const callGetFaqList = async () => {
    if (url[2] === "app-faqs") {
      if (url[3] === "En" || url[3] === "Tr") {
        props.fetchChangeLanguage(url[3]);
        i18next.changeLanguage(url[3]);
      }
    }
    let responce = await getRequestcall(GET_FAQ, "");
    if (responce?.status === 200) {
      const result = await responce?.json();
      if (result?.data?.length > 0) {
        setFaqList(result?.data);
      } else {
        setFaqList([]);
      }
    }
  };

  return (
    <>
      <aside className="help_page">
        {url[2] === "faqs" && (
          <>
            <div className="background-image">
              <LazyLoadImage alt="" src={StoreImages}></LazyLoadImage>
              <div className="search-store">
                <h5>{t("pages.FAQ")}</h5>
              </div>
            </div>
          </>
        )}
        <Container className="help_container pb-4">
          <div className="col-md-12">
            <Row className="help_row">
              <div className="col-12">
                <h5 className="font-22">{t("pages.help.getting")}</h5>
                <p className="secoundary">
                  {t(
                    "pages.Do you have questions in mind about the Girne online marketplace building platform? Find a few frequently asked questions and their answers below."
                  )}
                </p>
              </div>
              <div className="quetions mt-3">
                {faqList?.map((item, index) => (
                  <div
                    key={index.toString()}
                    className={
                      selectQuetion === index
                        ? "col-12 mb-3 quetion_list active"
                        : "col-12 mb-3 quetion_list"
                    }
                  >
                    <div className="card  quetiondiv">
                      <div className="card-body d-flex justify-content-between align-items-center">
                        <p
                          className="mb-0"
                          dangerouslySetInnerHTML={{
                            __html:
                              props?.language === "Tr"
                                ? item?.question_in_tr
                                : item?.question,
                          }}
                        />
                        <span
                          onClick={() =>
                            setSelectQuetion(
                              selectQuetion === index ? "" : index
                            )
                          }
                          className="arrow arrow-down transition"
                        >
                          <img src={chevron_down} alt="open"></img>
                        </span>
                      </div>
                    </div>
                    <div className="card  quetion_ans ">
                      <div
                        className="card-body"
                        dangerouslySetInnerHTML={{
                          __html:
                            props?.language === "Tr"
                              ? item?.description_in_tr
                              : item?.description,
                        }}
                      ></div>
                    </div>
                  </div>
                ))}
              </div>
            </Row>
          </div>
        </Container>
      </aside>
    </>
  );
}
const mapStateToProps = (state) => ({
  storeDetail: state?.dashboard?.storeDetail,
  access_token: state?.login.access_token,
  categories: state?.home.categories,
  language: state?.languageState?.language,
});

export default connect(mapStateToProps, {
  fetchHeaderContent,
  fetchChangeLanguage,
})(FaqsPage);
